(function(){
  function init(root){
    var track=root.querySelector('.slides__track'),slides=root.querySelectorAll('.slide'),dots=root.querySelectorAll('[data-dot]');
    if(!track||slides.length<2)return;
    var i=0,timer=null,speed=(parseInt(root.dataset.speed,10)||5)*1000;
    function go(n){i=(n+slides.length)%slides.length;track.scrollTo({left:slides[i].offsetLeft-track.offsetLeft,behavior:'smooth'});}
    function mark(){dots.forEach(function(d,k){d.setAttribute('aria-current',k===i?'true':'false');});}
    track.addEventListener('scroll',function(){var n=Math.round(track.scrollLeft/track.clientWidth);if(n!==i){i=n;mark();}},{passive:true});
    root.querySelector('[data-prev]').addEventListener('click',function(){go(i-1);});
    root.querySelector('[data-next]').addEventListener('click',function(){go(i+1);});
    dots.forEach(function(d,k){d.addEventListener('click',function(){go(k);});});
    function play(){stop();if(root.dataset.autoplay==='true'&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){timer=setInterval(function(){go(i+1);},speed);}}
    function stop(){if(timer){clearInterval(timer);timer=null;}}
    ['mouseenter','focusin','touchstart'].forEach(function(e){root.addEventListener(e,stop,{passive:true});});
    ['mouseleave','focusout'].forEach(function(e){root.addEventListener(e,play);});
    mark();play();
  }
  function all(){document.querySelectorAll('[data-slides]').forEach(init);}
  if(document.readyState!=='loading')all();else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',all);
})();
